export const PUBLIC_EVENT_PAGE_SELECT = [
  'id',
  'event_id',
  'slug',
  'title',
  'subtitle',
  'short_description',
  'body_markdown',
  'hero_image_url',
  'og_image_url',
  'venue_name',
  'venue_address',
  'template_key',
  'rsvp_enabled',
  'published',
  'closed_message',
  'thank_you_message',
  'created_at',
  'updated_at',
  'page_mode',
  'rsvp_config',
  'seo_config',
  'image_config',
  'thank_you_config',
  'sunset_config',
  'cta_config',
].join(', ');

export const PUBLIC_EVENT_SELECT = [
  'id',
  'name',
  'date_utc',
  'timezone',
  'event_category',
  'event_region',
].join(', ');
